import React from 'react'
import PropTypes from 'prop-types'
import {Divider, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import pdpPowerReviewOverride from '../../../theme/components/project/pdp-power-review-override'

const ReviewsAccordion = () => {
    const powerRatingImageStyles = {
        '.p-w-r .pr-star-v4-100-filled': {
            backgroundImage: `url(${getAssetUrl('static/img/rating-100.svg')})`
        },
        '.p-w-r .pr-star-v4-75-filled': {
            backgroundImage: `url(${getAssetUrl('static/img/rating-0.75.svg')})`
        },
        '.p-w-r .pr-star-v4-50-filled': {
            backgroundImage: `url(${getAssetUrl('static/img/rating-0.5.svg')})`
        },
        '.p-w-r .pr-star-v4-25-filled': {
            backgroundImage: `url(${getAssetUrl('static/img/rating-0.25.svg')})`
        },
        '.p-w-r .pr-star-v4-0-filled': {
            backgroundImage: `url(${getAssetUrl('static/img/rating-0.svg')})`
        },
        '.pr-subheadline': {
            backgroundImage: `url(${getAssetUrl('static/img/power-review-logo.svg')})`
        },
        '.pr-rd-sort': {
            backgroundImage: `url(${getAssetUrl('static/img/select-dropdown.png')})`
        },
        '.pr-rd-sort-group:before': {
            backgroundImage: `url(${getAssetUrl('static/img/sort-icon.png')})`
        }
    }
    return (
        <Box
            className="pr-custom-review-display"
            mt={6}
            sx={{...pdpPowerReviewOverride, ...powerRatingImageStyles}}
        >
            <Divider mb={8} bgColor="#DADADA" />
            <Box id="pr-reviewdisplay"></Box>
            <Divider mt={2} bgColor="#DADADA" />
        </Box>
    )
}

ReviewsAccordion.propTypes = {
    product: PropTypes.object
}

export default ReviewsAccordion
